import {
  Component,
  HostListener,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { PincodeTransmissionService } from '../../../../services/raintree/Transmission/pincode.service';
import { PincodeInterface } from '../../../../services/raintree/interfaces/pincode.interface';
import { RitwikTransmissionService } from '../../../../services/raintree/Transmission/ritwik.transmission.service';
import { SurnameTransmissionService } from '../../../../services/raintree/Transmission/surname.transmission';
import { FamilyCodeTransmissionService } from '../../../../services/raintree/Transmission/familyCode-transmission.service';

import { DPNFTransmissionService } from '../../../../services/raintree/Transmission/dpnf-transmission.service';
import { DpnfSuccessComponent } from '../../dpnf-success/dpnf-success.component';
import {
  MatAutocomplete,
  MatAutocompleteModule,
} from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FamilyCodeResponse } from '../../../../services/raintree/interfaces/family-code.interface';
import { ToastrService } from 'ngx-toastr';
import { LoaderComponent } from '../../../../common-component/loader/loader.component';

import { FcCodePopupComponent } from '../fc-code-popup/fc-code-popup.component';
import { CommonModule, DatePipe, isPlatformBrowser } from '@angular/common';
import { DpDatepickerComponent } from '../../../../common-component/dp-datepicker/dp-datepicker.component';
import { MasterSearchTransmissionService } from '../../../../services/raintree/Transmission/master-search.service';
import { RefreshedDateKey } from '../../../../enum/refresh-date';
@Component({
  selector: 'app-dpnf-popup',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    LoaderComponent,
    CommonModule,
    DpDatepickerComponent,
  ],
  providers: [DatePipe],
  templateUrl: './dpnf-popup.component.html',
  styleUrl: './dpnf-popup.component.scss',
})
export class DpnfPopupComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(PLATFORM_ID) private platformId: Object,
    public dialogRef: MatDialogRef<DpnfPopupComponent>,
    public ritwikTransmissionService: RitwikTransmissionService,
    public surnameTransmissionService: SurnameTransmissionService,
    public familyCodeTransmissionService: FamilyCodeTransmissionService,
    public pincodeTransmissionService: PincodeTransmissionService,
    public addDPNFTransmissionService: DPNFTransmissionService,
    public masterSearchService: MasterSearchTransmissionService,
    public dialog: MatDialog,
    public datePipe: DatePipe,
    private toaster: ToastrService,
    private formBuilder: FormBuilder
  ) { }
  @ViewChild('auto') auto!: MatAutocomplete;
  @ViewChild('auto1') auto1!: MatAutocomplete;
  @ViewChild('autofc') autofc!: MatAutocomplete;
  @ViewChild('autogl') autogl!: MatAutocomplete;
  @ViewChild('autohl') autohl!: MatAutocomplete;
  today: Date = new Date();
  years: number[] = [];
  months = [
    { value: 0, viewValue: 'January' },
    { value: 1, viewValue: 'February' },
    { value: 2, viewValue: 'March' },
    { value: 3, viewValue: 'April' },
    { value: 4, viewValue: 'May' },
    { value: 5, viewValue: 'June' },
    { value: 6, viewValue: 'July' },
    { value: 7, viewValue: 'August' },
    { value: 8, viewValue: 'September' },
    { value: 9, viewValue: 'October' },
    { value: 10, viewValue: 'November' },
    { value: 11, viewValue: 'December' },
  ];
  tempMon = this.months
  days: number[] = [];
  isLoader: boolean = false;
  isLoading: boolean = false;
  isMobile: boolean = false;
  stepperCount: number = 1;
  personalDetails!: FormGroup;
  gender: string[] = ['Female', 'Male'];
  addressDetails!: FormGroup;
  dateDetails!: FormGroup;
  personalDetailsVal: any = {};
  checkBoxClick: boolean = false;
  commentsLetterCount: number = 0;
  dikshaDistrictArr: any[] = [];
  dikshaState: string[] = [];
  dikshaPOArr: string[] = [];
  presPOArr: string[] = [];
  permPOArr: string[] = [];
  presDistrictArr: any[] = [];
  presState: string[] = [];
  permDistrictArr: string[] = [];
  permState: string[] = [];
  ritwikList: any[] = [];
  selectedLastName: boolean = false;
  selectedGuardianLastName: boolean = false;
  selectedHusbandLastName: boolean = false;
  selectedRitwik: boolean = false;
  selectedFC: boolean = false;
  show: boolean = false;
  married: number = 0;
  surnameList: any[] = [];
  FcDropDownList: any[] = [];
  fcDetails: any = [];
  stepperOneDone: boolean = false;
  stepperTwoDone: boolean = false;
  stepperThreeDone: boolean = false;
  stepperOne: boolean = false;
  lastRefreshedDate: any;
  stepperTwo: boolean = false;
  stepperThree: boolean = false;
  payload: any = [];
  maxDate: any = '';
  allowedKeys: any[] = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
  pincodeList: any = []
  ngOnInit() {
    this.maxDate = new Date();
    let refreshDate: any = JSON.parse(decodeURIComponent(atob(localStorage.getItem('refresh-date')!)))
    if (refreshDate) {
      this.lastRefreshedDate = refreshDate.filter((item: any) => item.configName.includes(RefreshedDateKey.DPNF))
      this.lastRefreshedDate = this.datePipe.transform(this.lastRefreshedDate[0].date, 'MMM d, y')
    }
    if (this.data.row != undefined && !this.data.new) {
      this.stepperOneDone = this.stepperThreeDone = this.stepperTwoDone = true;
    }
    this.isMobile = this.isMobileBrowser();
    this.dateDetails = this.formBuilder.group({
      dob: ['', Validators.required],
      dikshaYear: ['', Validators.required],
      dikshaMonth: [''],
      dikshaDay: [''],
      comments: ['', [Validators.maxLength(120)]],
    });
    this.personalDetails = this.formBuilder.group({
      fname: ['', Validators.required],
      mname: [''],
      lname: ['', Validators.required],
      gfname: ['', Validators.required],
      gmname: [''],
      glname: ['', Validators.required],
      gender: ['', Validators.required],
      maritalStatus: [''],
      rwname: [''],
      hfname: [''],
      hmname: [''],
      hlname: [''],
      fc: ['', [Validators.required]],
      contact: ['', [Validators.required]],
    });
    this.addressDetails = this.formBuilder.group({
      dikshaPincode: [
        '',
        [Validators.required, Validators.pattern('^[0-9]{6,6}$')],
      ],
      dikshaDistrict: ['', Validators.required],
      dikshaState: ['', Validators.required],
      dikshaAdd: ['', Validators.required],
      dikshaLandMark: ['', Validators.required],
      presPincode: [
        '',
        [Validators.required, Validators.pattern('^[0-9]{6,6}$')],
      ],
      presDistrict: ['', Validators.required],
      presState: ['', Validators.required],
      presAdd: ['', Validators.required],
      presPO: ['', Validators.required],
      permPincode: [
        '',
        [Validators.required, Validators.pattern('^[0-9]{6,6}$')],
      ],
      permDistrict: ['', Validators.required],
      permState: ['', Validators.required],
      permAdd: ['', Validators.required],
      permPO: ['', Validators.required],
      presLandMark: ['', Validators.required],
      permLandMark: ['', Validators.required],
      checkbox: [false],
    });
    this.initializeYears();
    if (this.data.row != undefined) this.prefillForm(this.data.row);
    this.dateDetails
      .get('dikshaYear')!
      .valueChanges.subscribe(() => {
        this.updateDays()
        this.dateDetails
          .get('dikshaMonth')?.setValue('')
        this.dateDetails
          .get('dikshaDay')?.setValue('')
      });
    this.dateDetails
      .get('dikshaMonth')!
      .valueChanges.subscribe(() => {
        this.updateDays()
        this.dateDetails
          .get('dikshaDay')?.setValue('')
      });
    this.personalDetails.get('gender')?.valueChanges.subscribe((value) => {
      if (this.data != null && this.data.gender != 'F')
        this.personalDetails.get('maritalStatus')?.setValue('');
      if (value == 'F') {
        this.show = true;
        this.personalDetails
          .get('maritalStatus')
          ?.setValidators(Validators.required);
      } else {
        this.show = false;
        this.married = 0;
        this.personalDetails.get('hlname')?.setValue('');
        this.personalDetails.get('hfname')?.setValue('');
        this.personalDetails.get('maritalStatus')?.setValue('');
        this.personalDetails.get('maritalStatus')?.clearValidators();
        this.personalDetails.get('maritalStatus')?.updateValueAndValidity();
        this.personalDetails.get('hfname')?.clearValidators();
        this.personalDetails.get('hfname')?.updateValueAndValidity();
        this.personalDetails.get('hlname')?.clearValidators();
        this.personalDetails.get('hlname')?.updateValueAndValidity();
      }
    });
    this.personalDetails
      .get('maritalStatus')
      ?.valueChanges.subscribe((value) => {
        this.onMarriageSelect(value);
      });
    this.dateDetails.get('comments')?.valueChanges.subscribe((value) => {
      this.commentsLetterCount = value.length;
    });
    this.addressDetails
      .get('dikshaPincode')
      ?.valueChanges.subscribe((value) => {
        this.dikshaDistrictArr = [];
        this.addressDetails.get('dikshaState')?.setValue('');
        this.addressDetails.get('dikshaDistrict')?.setValue('');
        if (value.length == 6) {
          this.pincodeTransmissionService.getStateDistrictV2(value).subscribe({
            next: (response: any) => {
              // if (!response.error) {
              // this.dikshaState = response.data.states;
              // this.dikshaDistrictArr = response.data.districts;
              // this.dikshaPOArr = response.data.pOffices;
              // if (this.dikshaDistrictArr.length == 1)
              //   this.addressDetails
              //     .get('dikshaDistrict')
              //     ?.setValue(this.dikshaDistrictArr[0]);
              // this.addressDetails
              //   .get('dikshaState')
              //   ?.setValue(this.dikshaState[0]);
              this.pincodeList = response.data
              this.dikshaState = Object.keys(this.pincodeList)

              if (this.dikshaState.length == 2) {
                this.dikshaState.forEach(item => {
                  this.dikshaDistrictArr = Object.keys(this.pincodeList[item])

                })
              } else {
                this.dikshaDistrictArr = Object.keys(this.pincodeList[this.dikshaState[0]])
                this.addressDetails.patchValue({
                  dikshaState: this.dikshaState[0]
                })
                if (this.dikshaDistrictArr.length == 1) {
                  this.addressDetails.patchValue({
                    dikshaDistrict: this.dikshaDistrictArr[0]
                  })
                }
                // }

              }
            },
            error: (error) => {
              this.toaster.error(error);
              this.addressDetails.get('dikshaPincode')?.setValue('');
            },
          });
        }
      });
    this.addressDetails.get('presPincode')?.valueChanges.subscribe((value) => {
      this.addressDetails.get('presState')?.setValue('');
      this.addressDetails.get('presDistrict')?.setValue('');
      this.addressDetails.get('presPO')?.setValue('');
      this.presDistrictArr = [];
      this.presPOArr = [];
      if (value.length == 6) {
        this.pincodeTransmissionService.getStateDistrictV2(value).subscribe({
          next: (response: any) => {
            // if (!response.error) {
            // this.pincodeList = response.data;
            //   this.presDistrictArr = response.data.districts;
            //   this.presPOArr = response.data.pOffices;
            //   if (this.presDistrictArr.length == 1)
            //     this.addressDetails
            //       .get('presDistrict')
            //       ?.setValue(this.presDistrictArr[0]);
            //   if (this.presPOArr.length == 1)
            //     this.addressDetails
            //       .get('presPO')
            //       ?.setValue(this.presPOArr[0]);
            //   this.addressDetails.get('presState')?.setValue(this.presState[0]);
            // }
            this.pincodeList = response.data
            this.presState = Object.keys(this.pincodeList)

            if (this.presState.length == 2) {
              this.presState.forEach(item => {
                this.presDistrictArr = Object.keys(this.pincodeList[item])

              })
            } else {
              this.presDistrictArr = Object.keys(this.pincodeList[this.presState[0]])
              this.addressDetails.patchValue({
                presState: this.presState[0]
              })
              if (this.presDistrictArr.length == 1) {
                this.addressDetails.patchValue({
                  presDistrict: this.presDistrictArr[0]
                })
                this.presPOArr = this.pincodeList[this.presState[0]][this.presDistrictArr[0]].po

                if (this.presPOArr.length <= 1) {
                  this.addressDetails.patchValue({
                    presPO: this.presPOArr[0]
                  })
                }
              }
              // }

            }
          },
          error: (error) => {
            this.toaster.clear();
            this.toaster.error(error);
            this.addressDetails.get('presPincode')?.setValue('');
          },
        });
      }
    });
    this.addressDetails.get('permPincode')?.valueChanges.subscribe((value) => {
      if (!this.checkBoxClick) {
        this.addressDetails.get('permState')?.setValue('');
        this.addressDetails.get('permDistrict')?.setValue('');
        this.addressDetails.get('permPO')?.setValue('');
        this.permDistrictArr = [];
        this.permPOArr = [];
        if (value.length == 6) {
          this.pincodeTransmissionService.getStateDistrictV2(value).subscribe({
            next: (response: any) => {
              // if (!response.error) {
              //   this.permState = response.data.states;
              //   this.permDistrictArr = response.data.districts;
              //   this.permPOArr = response.data.pOffices;
              //   if (this.permDistrictArr.length == 1)
              //     this.addressDetails
              //       .get('permDistrict')
              //       ?.setValue(this.permDistrictArr[0]);
              //   if (this.permPOArr.length == 1)
              //     this.addressDetails
              //       .get('permPO')
              //       ?.setValue(this.permPOArr[0]);
              //   this.addressDetails
              //     .get('permState')
              //     ?.setValue(this.permState[0]);
              // }
               this.pincodeList = response.data
            this.permState = Object.keys(this.pincodeList)

            if (this.permState.length == 2) {
              this.permState.forEach(item => {
                this.permDistrictArr = Object.keys(this.pincodeList[item])

              })
            } else {
              this.permDistrictArr = Object.keys(this.pincodeList[this.permState[0]])
              this.addressDetails.patchValue({
                permState: this.permState[0]
              })
              if (this.permDistrictArr.length == 1) {
                this.addressDetails.patchValue({
                  permDistrict: this.permDistrictArr[0]
                })
                this.permPOArr = this.pincodeList[this.permState[0]][this.permDistrictArr[0]].po

                if (this.permPOArr.length <= 1) {
                  this.addressDetails.patchValue({
                    permPO: this.permPOArr[0]
                  })
                }
              }
              // }

            }
            },
            error: (error) => {
              this.toaster.clear();
              this.toaster.error(error);
              this.addressDetails.get('permPincode')?.setValue('');
            },
          });
        }
      }
    });
    this.personalDetails.get('rwname')?.valueChanges.subscribe((value) => {
      this.selectedRitwik = false;
      if (value.length >= 3) {
        this.ritwikTransmissionService.getRitwikListV2(value).subscribe({
          next: (response: any) => {
            if (!response.error) {
              this.ritwikList = response.data;
            }
          },
          error: (error) => {
            this.toaster.clear();
            this.toaster.error(error);
          },
        });
      } else this.ritwikList = [];
    });
    this.personalDetails.get('fc')?.valueChanges.subscribe((value) => {
      const containsOnlyNumbers = /^\d+$/.test(value);
      if (value.length == 12 && containsOnlyNumbers) {
        this.selectedFC = false;
        this.isLoading = true;
        this.familyCodeTransmissionService.getFamilyDetails(value).subscribe({
          next: (response: FamilyCodeResponse) => {
            if (!response.error) {
              this.fcDetails = response.data;
              this.isLoading = false;
            }
          },
          error: (error) => {
            this.isLoading = false;
            this.toaster.error(
              'Incorrect Family Code. Please check the code again.'
            );
          },
        });
      } else this.fcDetails = [];
    });
    this.personalDetails.get('lname')?.valueChanges.subscribe((value) => {
      this.selectedLastName = false;
      if (value.length >= 3) {
        this.surnameTransmissionService
          .getSurnameList({ input: value })
          .subscribe({
            next: (response: any) => {
              if (!response.error) {
                this.surnameList = response.data;
              }
            },
            error: (error) => {
              this.toaster.clear();
              this.toaster.error(error);
            },
          });
      } else this.surnameList = [];
    });
    this.personalDetails.get('glname')?.valueChanges.subscribe((value) => {
      this.selectedGuardianLastName = false;
      if (value.length >= 3) {
        this.surnameTransmissionService
          .getSurnameList({ input: value })
          .subscribe({
            next: (response: any) => {
              if (!response.error) {
                this.surnameList = response.data;
              }
            },
            error: (error) => {
              this.toaster.clear();
              this.toaster.error(error);
            },
          });
      } else this.surnameList = [];
    });
    this.personalDetails.get('hlname')?.valueChanges.subscribe((value) => {
      this.selectedHusbandLastName = false;
      if (this.married == 1) {
        this.personalDetails.get('hlname')?.setValidators(Validators.required);
        if (value.length >= 3) {
          this.surnameTransmissionService
            .getSurnameList({ input: value })
            .subscribe({
              next: (response: any) => {
                if (!response.error) {
                  this.surnameList = response.data;
                }
              },
              error: (error) => {
                this.toaster.clear();
                this.toaster.error(error);
              },
            });
        } else this.surnameList = [];
      }
    });
    this.dateDetails.get('dikshaYear')?.valueChanges.subscribe((value) => {
      this.data.year = null;
    });
    // this.personalDetails
    //   .get('maritalStatus')
    //   ?.valueChanges.subscribe((value) => {
    //   });
  }
  getPinDetails(event: any, type: string) {
    if (type == 'dikState') {
      this.dikshaDistrictArr = Object.keys(this.pincodeList[event.value])
      this.addressDetails.patchValue({
        dikshaDistrict: this.dikshaDistrictArr[0]
      })
    }else if(type == 'presState') {
      this.presDistrictArr = Object.keys(this.pincodeList[event.value]);
      this.presPOArr = this.pincodeList[event.value][this.presDistrictArr[0]].po
      this.addressDetails.patchValue({
        presDistrict: this.presDistrictArr[0]
      })
    if(this.presPOArr.length <= 1){
       this.addressDetails.patchValue({
        presPO: this.presPOArr[0]
      })
    }
    }else if (type == 'permState') {
      this.permDistrictArr = Object.keys(this.pincodeList[event.value])
      this.permPOArr = this.pincodeList[event.value][this.permDistrictArr[0]].po

      this.addressDetails.patchValue({
        permDistrict: this.permDistrictArr[0]
      })
       if(this.permPOArr.length <= 1){
       this.addressDetails.patchValue({
        permPO: this.permPOArr[0]
      })
    }
    }

  }
  @HostListener('paste', ['$event']) blockPaste(e: ClipboardEvent) {
    e.preventDefault();
  }
  @HostListener('copy', ['$event']) blockCopy(e: ClipboardEvent) {
    e.preventDefault();
  }
  initializeYears(): void {
    let year: any = this.datePipe.transform(new Date(this.lastRefreshedDate), 'yyyy')
    for (let i = 1950; i <= year; i++) {
      this.years.push(i);
    }
  }
  initializeMonths(): void {
  };
  prefillForm(data: any) {
    this.personalDetails.patchValue({
      fname: data.dikshyarthiFName,
      mname: data.dikshyarthiMName != null ? data.dikshyarthiMName : '',
      lname: data.dikshyarthiLName,
      gfname: data.guardianFName,
      gmname: data.guardianMName != null ? data.guardianMName : '',
      glname: data.guardianLName,
      gender: data.gender,
      maritalStatus: data.maritialStatus != null ? data.maritialStatus : '',
      hfname: data.husbandFName != null ? data.husbandFName : '',
      hmname: data.husbandMName != null ? data.husbandMName : '',
      hlname: data.husbandLName != null ? data.husbandLName : '',
      rwname: data.ritwickName != null ? data.ritwickName : '',
      fc: data.dikshyarthiName != null ? data.dikshyarthiName : '',
      contact: data.contactNumber,
    });
    this.addressDetails.patchValue({
      dikshaPincode: data.pincode,
      dikshaDistrict: data.district,
      dikshaState: data.state,
      dikshaAdd: data.address,
      dikshaLandMark: data.landmark,
      presPincode: data.currentPinCode,
      presDistrict: data.currentDistrict,
      presState: data.currentState,
      presAdd: data.currentAddress,
      presPO: data.currentPO,
      presLandMark: data.currentLandmark,
      permPincode: data.permPincode,
      permDistrict: data.permDistrict,
      permState: data.permState,
      permAdd: data.permAddress,
      permPO: data.permPO,
      permLandMark: data.permLandmark,
    });
    this.dikshaDistrictArr[0] = data.district;
    this.presDistrictArr[0] = data.currentDistrict;
    this.permDistrictArr[0] = data.permDistrict;
    this.presPOArr[0] = data.currentPO;
    this.permPOArr[0] = data.permPO;
    this.dateDetails.patchValue({
      dob: data.dob,
      dikshaYear: data.year,
      dikshaMonth: data.month != null ? data.month : '',
      dikshaDay: data.day != null ? data.day : '',
      comments: data.comment,
    });
    this.updateDays();
    if (data.maritialStatus != null || data.gender != 'M') {
      this.show = true;
      this.married = 2;
    }
    this.selectedRitwik = true;
    if (data.familyCode != null) this.selectedFC = true;
    if (data.dikshyarthiLName != null) this.selectedLastName = true;
    if (data.husbandLName != null) this.selectedHusbandLastName = true;
    if (data.guardianLName != null) this.selectedGuardianLastName = true;
    if (
      data.maritialStatus != null &&
      data.maritialStatus.toLowerCase() == 'm'
    ) {
      this.married = 1;
      this.personalDetails.get('hfname')?.setValidators(Validators.required);
      this.personalDetails.get('hlname')?.setValidators(Validators.required);
    }
    if (data.gender == 'F' && data.maritialStatus == null) {
      this.personalDetails
        .get('maritalStatus')
        ?.setValidators(Validators.required);
      this.married = 0;
    }
    if (data != null) {
      this.payload = {
        ...this.payload,
        familyCode: data.familyCode,
        phlMemCode: data.phlMemCode,
        phlMemName: data.phlMemName,
        phlMemSurname: data.phlMemSurname,
        lastIstDate: data.lastIstDate,
      };
    }
  }
  updateDays(): void {
    const year = this.dateDetails.get('dikshaYear')!.value;
    const month = this.dateDetails.get('dikshaMonth')!.value;
    let maxMonth: any = this.datePipe.transform(new Date(this.lastRefreshedDate), 'MM')
    let maxYear: any = this.datePipe.transform(new Date(this.lastRefreshedDate), 'yyyy')
    if (year !== '' && month !== '') {
      const startDate = new Date(year, month, 1);
      let maxDate: any = this.datePipe.transform(new Date(this.lastRefreshedDate), 'd')
      const numDays: any = this.months[maxMonth - 1].value === month ? maxDate : new Date(
        startDate.getFullYear(),
        startDate.getMonth() + 1,
        0
      ).getDate();
      this.days = Array.from({ length: numDays }, (_, i) => i + 1);
    } else if (year !== '' && month === '') {
      this.months = this.tempMon
      this.months = parseInt(maxYear) === year ? this.months.filter((month: any) => month.value < maxMonth) : this.months;
      this.days = []
    } else {
      this.days = [];
    }
  }
  onSelectDropDown(event: any) {
    if (event != null) {
      this.personalDetails.get('rwname')?.setValue(event.wfn);
      this.selectedRitwik = true;
      this.payload = {
        ...this.payload,
        ritwickName: event.wfn,
        ritwickCode: event.rc,
      };
    }
  }
  onSelectFCDropDown(event: any) {
    this.isLoading = true;
    this.familyCodeTransmissionService
      .verifyFamilyDetails(event.mem_key)
      .subscribe({
        next: (response: any) => {
          this.personalDetails
            .get('fc')
            ?.setValue(`${event.mem_name} ${event.mem_surname}`);
          if (!response.data.isAllowed) {
            this.personalDetails.get('fc')?.setValue('');
            this.isLoading = false;
            this.toaster.error(response.data.message);
          } else {
            const name = event.mem_name.trim().toLowerCase();
            const firstName = this.personalDetails
              .get('fname')
              ?.value.trim()
              .toLowerCase();
            const surname =
              event.mem_surname !== null
                ? event.mem_surname.trim().toLowerCase()
                : '';
            const lastName = this.personalDetails
              .get('lname')
              ?.value.trim()
              .toLowerCase();
            const middleName = this.personalDetails
              .get('mname')
              ?.value.trim()
              .toLowerCase();
            const fullName =
              firstName +
              (middleName != '' ? ' ' + middleName + ' ' : ' ') +
              lastName;
            const philFullname = name + ' ' + surname;
            if (fullName !== philFullname) {
              this.isLoading = false;
              const dialogRef = this.dialog.open(FcCodePopupComponent);
              dialogRef.afterClosed().subscribe((value) => {
                if (value) {
                  this.selectedFC = true;
                  let surname =
                    event.mem_surname !== null ? event.mem_surname : '';
                  this.personalDetails
                    .get('fc')
                    ?.setValue(`${event.mem_name} ${surname}`);
                  this.payload = {
                    ...this.payload,
                    familyCode: event.mem_family_code,
                    phlMemCode: event.mem_key,
                    phlMemName: event.mem_name,
                    phlMemSurname: event.mem_surname,
                    lastIstDate: event.mem_last_transaction_date,
                  };
                } else this.personalDetails.get('fc')?.setValue('');
              });
            } else {
              this.selectedFC = true;
              this.payload = {
                ...this.payload,
                familyCode: event.mem_family_code,
                phlMemCode: event.mem_key,
                phlMemName: event.mem_name,
                phlMemSurname: event.mem_surname,
                lastIstDate: event.mem_last_transaction_date,
              };
              this.isLoading = false;
            }
          }
        },
        error: (error) => {
          this.toaster.clear();
          this.toaster.error(error);
        },
      });
  }
  onSelectLastNameDropDown(event: any, type: string) {
    if (event != null) {
      if (type === 'm') {
        this.personalDetails.get('lname')?.setValue(event);
        this.selectedLastName = true;
      } else if (type == 'g') {
        this.personalDetails.get('glname')?.setValue(event);
        this.selectedGuardianLastName = true;
      } else {
        this.personalDetails.get('hlname')?.setValue(event);
        this.selectedHusbandLastName = true;
      }
    }
  }
  onSelectPODropDown(event: any, type: string) {
    if(type == 'presDistrict'){
      this.presPOArr = this.pincodeList[this.presState[0]][event.value].po

      if(this.presPOArr.length <=1){
        this.addressDetails.patchValue({
          presPO: this.presPOArr[0]
        })
      }
    }
    if(type == 'permDistrict'){
       this.permPOArr = this.pincodeList[this.permState[0]][event.value].po

      if(this.presPOArr.length <=1){
        this.addressDetails.patchValue({
          permPO: this.permPOArr[0]
        })
      }
    }
    // const select = event.target as HTMLSelectElement;
    // const rn = select.value;
    // if (rn != null) {
    //   if (type == 'pPO') {
    //     this.personalDetails.get('presPO')?.setValue(rn);
    //   } else if (type == 'pDistrict') {
    //     this.personalDetails.get('presDistrict')?.setValue(rn);
    //   } else if (type == 'dPO') {
    //     this.personalDetails.get('dikshaPO')?.setValue(rn);
    //   } else if (type == 'dDistrict') {
    //     this.personalDetails.get('dikshaDistrict')?.setValue(rn);
    //   } else if (type == 'permDistrict') {
    //     this.personalDetails.get('permDistrict')?.setValue(rn);
    //   } else if (type == 'permPO') {
    //     this.personalDetails.get('permPO')?.setValue(rn);
    //   }
    // }
  }
  onInfoClick() {
    if (this.stepperOneDone) this.stepperCount = 1;
  }
  onAddClick() {
    if (this.stepperTwoDone) this.stepperCount = 2;
  }
  onDateClick() {
    if (this.stepperThreeDone) this.stepperCount = 3;
  }
  onMarriageSelect(event: any) {
    if (event == 'M') {
      this.married = 1;
      this.personalDetails.get('maritalStatus')?.setValue('M');
      this.personalDetails.get('hfname')?.setValidators(Validators.required);
      this.personalDetails.get('hlname')?.setValidators(Validators.required);
      this.payload = { ...this.payload, maritialStatus: 'M' };
    } else if (event == 'U') {
      this.married = 2;
      this.payload = { ...this.payload, maritialStatus: 'U' };
      this.personalDetails.get('hfname')?.setValue('');
      this.personalDetails.get('hlname')?.setValue('');
      this.personalDetails.get('maritalStatus')?.setValue('U');
      this.personalDetails.get('hfname')?.clearValidators();
      this.personalDetails.get('hfname')?.updateValueAndValidity();
      this.personalDetails.get('hlname')?.clearValidators();
      this.personalDetails.get('hlname')?.updateValueAndValidity();
    }
  }
  onCheckboxChange(event: any) {
    this.checkBoxClick = !this.checkBoxClick;
    if (this.checkBoxClick) {
      this.addressDetails
        .get('permPincode')
        ?.setValue(this.addressDetails.get('presPincode')?.value);
      this.addressDetails
        .get('permPO')
        ?.setValue(this.addressDetails.get('presPO')?.value);
      this.addressDetails
        .get('permDistrict')
        ?.setValue(this.addressDetails.get('presDistrict')?.value);
      this.addressDetails
        .get('permState')
        ?.setValue(this.addressDetails.get('presState')?.value);
      this.addressDetails
        .get('permAdd')
        ?.setValue(this.addressDetails.get('presAdd')?.value);
      this.addressDetails
        .get('permLandMark')
        ?.setValue(this.addressDetails.get('presLandMark')?.value);
      this.addressDetails.get('checkbox')?.setValue(true);
      this.permDistrictArr = [];
      this.permPOArr = [];
      console.log(this.addressDetails.get('permPO')?.value);
    } else {
      this.addressDetails.get('permPincode')?.setValue('');
      this.addressDetails.get('permDistrict')?.setValue('');
      this.addressDetails.get('permState')?.setValue('');
      this.addressDetails.get('permAdd')?.setValue('');
      this.addressDetails.get('permPO')?.setValue('');
      this.addressDetails.get('checkbox')?.setValue(false);
      this.addressDetails.get('permLandMark')?.setValue('');
    }
  }
  firstDigit: number = 0;
  markAllAsTouched(stepNo: number) {
    if (stepNo == 1) this.stepperOne = true;
    else if (stepNo == 2) this.stepperTwo = true;
    else this.stepperThree = true;
    Object.values(this.personalDetails.controls).forEach((control) => {
      control.markAsTouched();
    });
    const contactValue = this.personalDetails.get('contact')?.value?.toString();
    if (contactValue) {
      this.firstDigit = parseInt(contactValue.charAt(0), 10);
      if (this.firstDigit < 6) {
        this.personalDetails.get('contact')?.markAsTouched;
        this.personalDetails.get('contact')?.setValue('');
      }
    }
  }
  onNextClick() {
    if (
      this.personalDetails.get('rwname')?.value != '' &&
      !this.selectedRitwik
    ) {
      this.personalDetails.get('rwname')?.setValidators(Validators.required);
    }
    if (
      this.personalDetails.invalid ||
      !this.selectedFC ||
      !this.selectedGuardianLastName ||
      !this.selectedLastName ||
      !this.selectedHusbandLastName
    ) {
      this.markAllAsTouched(1);
    }
    if (
      this.personalDetails.valid &&
      this.selectedFC &&
      this.selectedLastName &&
      this.selectedGuardianLastName
    ) {
      if (!this.selectedHusbandLastName && this.married == 1)
        this.markAllAsTouched(1);
      else {
        this.payload = {
          ...this.payload,
          dikshyarthiFName: this.personalDetails.get('fname')?.value,
          dikshyarthiMName: this.personalDetails.get('mname')?.value,
          dikshyarthiLName: this.personalDetails.get('lname')?.value,
          gender: this.personalDetails.get('gender')?.value,
          guardianFName: this.personalDetails.get('gfname')?.value,
          guardianMName: this.personalDetails.get('gmname')?.value,
          guardianLName: this.personalDetails.get('glname')?.value,
          husbandFName: this.personalDetails.get('hfname')?.value,
          husbandMName: this.personalDetails.get('hmname')?.value,
          husbandLName: this.personalDetails.get('hlname')?.value,
          contactNumber: this.personalDetails.get('contact')?.value,
        };
        if (this.personalDetails.get('maritalStatus')?.value && !this.payload?.maritalStatus)
          this.payload = { ...this.payload, maritialStatus: this.personalDetails.get('maritalStatus')?.value }
        this.stepperCount += 1;
        console.log(this.stepperCount);
        this.stepperOneDone = true;
      }
    }
  }
  onSecondNextClick() {
    console.log(this.addressDetails.value);
    if (this.addressDetails.valid) {
      this.payload = {
        ...this.payload,
        address: this.addressDetails.get('dikshaAdd')?.value,
        landmark: this.addressDetails.get('dikshaLandMark')?.value,
        pincode: this.addressDetails.get('dikshaPincode')?.value,
        district: this.addressDetails.get('dikshaDistrict')?.value,
        state: this.addressDetails.get('dikshaState')?.value,
        permState: this.addressDetails.get('permState')?.value,
        permDistrict: this.addressDetails.get('permDistrict')?.value,
        permPinCode: this.addressDetails.get('permPincode')?.value,
        permAddress: this.addressDetails.get('permAdd')?.value,
        permLandmark: this.addressDetails.get('permLandMark')?.value,
        permPO: this.addressDetails.get('permPO')?.value,
        currentState: this.addressDetails.get('presState')?.value,
        currentDistrict: this.addressDetails.get('presDistrict')?.value,
        currentPinCode: this.addressDetails.get('presPincode')?.value,
        currentAddress: this.addressDetails.get('presAdd')?.value,
        currentLandmark: this.addressDetails.get('presLandMark')?.value,
        currentPO: this.addressDetails.get('presPO')?.value,
      };
      this.stepperCount += 1;
      this.stepperTwoDone = true;
    } else this.markAllAsTouched(2);
  }
  onPreviousClick() {
    if (
      this.dateDetails.get('dob')?.value?.length > 0 &&
      this.dateDetails.get('comments')?.value?.length > 0 &&
      this.dateDetails.get('dikshaYear')?.value != ''
    )
      this.stepperThreeDone = true;
    this.stepperCount -= 1;
  }
  checkDateVal(): boolean | undefined {
    // if (new Date(this.dateDetails.get('dob')?.value) > new Date()) {
    //   this.toaster.error('Do not Enter Future Date');
    //   this.dateDetails.get('dob')?.setValue('');
    //   return false;
    // }
    if (
      this.dateDetails.get('dob')?.value != '' &&
      this.dateDetails.get('dikshaYear')?.value -
      new Date(this.dateDetails.get('dob')?.value).getFullYear() <
      5
    ) {
      this.toaster.error('Check Diksha & Birth Date Again');
      this.dateDetails.get('dob')?.setValue('');
      this.dateDetails.get('dikshaYear')?.setValue('');
      this.dateDetails.get('dikshaMonth')?.setValue('');
      this.dateDetails.get('dikshaDay')?.setValue('');
      // this.dateDetails.get('comments')?.setValue('');
      return false;
    }
    this.stepperThreeDone = true;
    return true;
  }
  isMobileBrowser(): boolean {
    const userAgent = isPlatformBrowser(this.platformId)
      ? window.navigator.userAgent
      : '';
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    );
  }
  onSubmitClick() {
    if (this.checkDateVal()) {
      this.payload = {
        ...this.payload,
        dob: this.dateDetails.get('dob')?.value,
        year: this.dateDetails.get('dikshaYear')?.value,
        month: this.dateDetails.get('dikshaMonth')?.value,
        day: this.dateDetails.get('dikshaDay')?.value,
        comments: this.dateDetails.get('comments')?.value,
        // uiState: this.data.state,
        // uiDistrict: this.data.district
      };
      this.addDPNFTransmissionService.addDPNF(this.payload).subscribe({
        next: (response: any) => {
          if (!response.error) {
            this.dialog.open(DpnfSuccessComponent, {
              panelClass: 'common-pannel-dialog-container',
              data: {
                heading: 'Data has been added to DPNF successfully',
              },
            });
            this.dialogRef.close(true);
          }
        },
        error: (error) => {
          this.toaster.clear();
          this.toaster.error(error);
        },
      });
    } else this.markAllAsTouched(3);
  }
  restrictFCInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;
    const pattern = /[0-9]/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input) || limit.value.length > 11) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }
  restrictNumberInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;
    const pattern = /[0-9]/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input) || limit.value.length > 5) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }
  restrictContactInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;
    const pattern = /[0-9]/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input) || limit.value.length > 9) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }
  restrictAddressInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;
    const pattern = /^[a-zA-Z0-9@,-\s]+$/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input) || limit.value.length > 120) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }
  onSaveClick() {
    if (this.checkDateVal()) {
      this.payload = {
        ...this.payload,
        id: this.data.row.id,
        dob: this.dateDetails.get('dob')?.value,
        year: this.dateDetails.get('dikshaYear')?.value,
        month: this.dateDetails.get('dikshaMonth')?.value,
        day: this.dateDetails.get('dikshaDay')?.value,
        comments: this.dateDetails.get('comments')?.value,
        uiState: this.data.state,
        uiDistrict: this.data.district
      };
      this.addDPNFTransmissionService.editDPNF(this.payload).subscribe({
        next: (response: any) => {
          if (!response.error) {
            this.dialog.open(DpnfSuccessComponent, {
              panelClass: 'common-pannel-dialog-container',
              data: {
                heading: 'Data has been updated successfully',
              },
            });
            this.dialogRef.close(true);
          }
        },
        error: (error) => {
          this.toaster.clear();
          this.toaster.error(error);
        },
      });
    } else {
      this.markAllAsTouched(3);
    }
  }
  restrictNameInput(event: KeyboardEvent): void {
    const input = event.key;
    const pattern = /^[a-zA-Z\s]+$/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input)) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }
}
